@if(incomeTaxEntity$ | async) {
  <form [formGroup]="formGroup">
    @if (ingehoudenDividendBelasting.length > 0) {
      <div formArrayName="belasting">
        @for (item of ingehoudenDividendBelasting.controls; track item; let i = $index) {
          <div [formGroupName]="i">
            <div class="row col-auto" style="--bs-gutter-x: 0.5rem;">
              <snelstart-ui-text-form-control [label]="i === 0 ? 'Rekeningnummer' : ''"
                                              class="custom-input-250"
                                              formControlName="rekeningNummer"
                                              id="rekeningNummer"
              >
              </snelstart-ui-text-form-control>
              <snelstart-ui-number-form-control [decimals]="0"
                                                [label]="i === 0 ? 'Dividend box 3' : ''"
                                                align="right"
                                                class="custom-input-200"
                                                formControlName="dividendBox3"
                                                id="dividendBox3"
                                                prefix="€"
              >
              </snelstart-ui-number-form-control>
              <snelstart-ui-number-form-control [decimals]="0"
                                                [label]="i === 0 ? 'Dividendbelasting box 3' : ''"
                                                align="right"
                                                class="custom-input-200"
                                                formControlName="dividendbelastingBox3"
                                                id="dividendbelastingBox3"
                                                prefix="€"
              >
              </snelstart-ui-number-form-control>
              <snelstart-ui-number-form-control [decimals]="0"
                                                [label]="i === 0 ? 'Dividend box 2' : ''"
                                                align="right"
                                                class="custom-input-200"
                                                formControlName="dividendBox2"
                                                id="dividendBox2"
                                                prefix="€"
              >
              </snelstart-ui-number-form-control>
              <snelstart-ui-number-form-control [decimals]="0"
                                                [label]="i === 0 ? 'Dividendbelasting box 2' : ''"
                                                align="right"
                                                class="custom-input-200"
                                                formControlName="dividendbelastingBox2"
                                                id="dividendbelastingBox2"
                                                prefix="€"
              >
              </snelstart-ui-number-form-control>
              <snelstart-ui-button (click)="verwijderRij(i)"
                                   [class]="i === 0 ? 'firstrowbutton col-auto ' : 'col-auto '"
                                   icon="trash"
                                   iconType="light"
                                   id="buttonDeleteKosten"
                                   size="medium"
                                   type="secondary"
              >
              </snelstart-ui-button>
            </div>
          </div>
        }
      </div>
    }
  </form>
  <snelstart-ui-button (click)="addRij()" class="snelstart-ui-button" icon="plus"
                       type="link">Dividendbelasting toevoegen
  </snelstart-ui-button>
}
